import React, { PureComponent } from 'react';
import { string, bool, shape, func } from 'prop-types';
import classnames from 'classnames';
import './Toggle.scss';

export default class Toggle extends PureComponent {
    static propTypes = {
        active: bool,
        attributeName: string,
        label: string.isRequired,
        className: string,
        theme: shape({
            root: string,
        }),
        disabled: bool,
        onClick: func.isRequired,
    };

    static defaultProps = {
        attributeName: null,
        active: false,
        className: null,
        disabled: false,
        theme: {},
    };

    handleRootClick = evt => {
        const { onClick, active, attributeName } = this.props;
        if (onClick) {
            onClick(!active, attributeName, evt);
        }
    };

    render() {
        const {
            className,
            theme = {},
            active,
            label,
            attributeName,
            disabled,
            ...otherProps
        } = this.props;
        const rootClassnames = classnames(
            'toggle-filter',
            {
                'toggle-filter--active': active,
                'toggle-filter--disabled': disabled,
            },
            className,
            theme.root,
        );

        return (
            <button
                {...otherProps}
                className={rootClassnames}
                data-filter-value={attributeName}
                onClick={this.handleRootClick}
            >
                <div className="toggle-filter__title">
                    <span className="toggle-filter__title__name">{label}</span>
                </div>
            </button>
        );
    }
}
